import { Paper, styled, Table, TableBody, TableCell, tableCellClasses, TableContainer, TableHead, TablePagination, TableRow, } from "@mui/material";
import React, { useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import Home from "../../home/Home";
import { getDate } from "../../Utils/Common";
import { useEffect } from "react";
import BillingReportsService from "../../../Services/Reports/BillingReportsService";
import Snackbar from '../../Snacbar'
import HashLoader from "react-spinners/HashLoader";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: 'rgb(61, 195, 177)',
    color: 'black',
    textAlign: "center",
    fontFamily: 'Times New Roman',
    fontWeight: 'bold',
  },
  [`&.${tableCellClasses.body}`]: {
    textAlign: "center",
    fontSize: 14,
    fontFamily: 'Times New Roman',
  },
}));
const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
}));
const ItemPap = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
  border: " 1px solid black",
  // backgroundColor: "#C8EDE7",
  height: "100%",
}));
const ItemPap1 = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
  border: " 1px solid black",
  backgroundColor: "white",
}));

function GSTR1Reports() {
  const mystyle = {
    border: " 1px solid black", fontFamily: 'Times New Roman',

    width: "10rem",
  };
  const mystyle1 = {
    fontWeight: "bolder", fontFamily: 'Times New Roman',

    color: "#0b64c5",
  };
  const [loading, setloading] = useState(false)
  const [message, setMessage] = useState('');
  const [open, setOpen] = useState(false);
  const [severit, setseverit] = useState('');
  const [FilteredDetails, setFilteredDetails] = useState([]);

  const [details1, setdetails1] = useState([]);
  const [details2, setdetails2] = useState([]);
  const [details3, setdetails3] = useState([]);
  const [gstrValues, setgstrValues] = useState({
    from: getDate(),
    to: getDate(),
    branch: '-1',
    importer: '-1',
    operation: '-1',
  });
  const fromhandlechange = (e) => {
    setgstrValues({ ...gstrValues, from: e.target.value })
  };
  const tohandlechange = (e) => {
    setgstrValues({ ...gstrValues, to: e.target.value })
  };
  const branchhandlechange = (e) => {
    setgstrValues({ ...gstrValues, branch: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, '') })
  };
  const importerhandlechange = (e) => {
    setgstrValues({ ...gstrValues, importer: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, '') })
  };
  const operationhandlechange = (e) => {
    setgstrValues({ ...gstrValues, operation: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, '') })
  };
  //
  const [showProcs, setshowProcs] = useState(false);
  const [refreshProcs, setrefreshProcs] = useState(false);
  const [pdfexportProcs, setpdfexportProcs] = useState(false);
  const [excelexportProcs, setexcelexportProcs] = useState(false);
  //error message
  const handleClose = () => {
    setOpen(false)
  }
  // getfunction//////
  const getbranch = () => {
    BillingReportsService.getRegionalOfficeDetails().then(res => {
      setdetails1(res.data)
    })
  }
  const getimporter = () => {
    BillingReportsService.getImporterDetail().then(res => {
      setdetails2(res.data)
    })
  }
  ///button operations
  const showBtnClick = () => {
    setshowProcs(true)
    setloading(true)
    setdetails3([])
    setFilteredDetails([])
    let details = {
      fromDate: gstrValues.from, toDate: gstrValues.to, iecNo: gstrValues.importer,
      oprType: gstrValues.operation, branchId: gstrValues.branch
    }
    BillingReportsService.getGSTR1Report(details).then((res) => {
      const data = res.data;
      const details = data.map((res) => res)
      if (details[0] === [] || !details[0]) {
        setMessage('No Data Found')
        setseverit('warning')
        setOpen(true)
        setshowProcs(false)
        setloading(false)
      } else {
        setdetails3(res.data);
        setFilteredDetails(res.data);
        setshowProcs(false)
        setloading(false)
      }
    })
  }
  const refreshBtnClick = () => {
    setrefreshProcs(true)
    setshowProcs(false)
    setgstrValues({ ...gstrValues, from: getDate(), to: getDate(), branch: '-1', importer: '-1', operation: '', });
    setdetails3([]);
    setFilteredDetails([]);
    setrefreshProcs(false)
  }
  const Exp_PdfBtnClick = () => {
    setpdfexportProcs(true)
    let details = { fromDate: gstrValues.from, toDate: gstrValues.to, iecNo: gstrValues.importer, oprType: gstrValues.operation, branchId: gstrValues.branch }
    BillingReportsService.GSTR1_report(details).then((res) => {
      const filename = res.data.message;
      // window.open('http://localhost:8080/ExportFiles/' + filename.toString(), "_blank");
      window.open('http://35.154.221.117:8081/ExportFiles/' + filename.toString(), "_blank");
    })
    setpdfexportProcs(false)
  }
  const Exp_ExcelBtnClick = () => {
    setexcelexportProcs(true)
    if (!details3[0]) {
      setMessage('Datagrid Should not be empty');
      setseverit('warning')
      setOpen(true)
      setexcelexportProcs(false)
    } else {
      console.log('else')
      var tableContent, contenall = '';
      for (let i = 0; i < details3.length; i++) {
        if (details3[i].iecGSTINno !== '') {
          tableContent = details3[i].iecGSTINno + "!"
        } else {
          tableContent += '   !'
        }
        if (details3[i].iecName !== '') {
          tableContent += details3[i].iecName + "!"
        }
        else {
          tableContent += '  !';
        }
        if (details3[i].invoiceNo !== '') {
          tableContent += details3[i].invoiceNo + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].billPaidDate !== '') {
          tableContent += details3[i].billPaidDate + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].invoiceValue !== '') {
          tableContent += details3[i].invoiceValue + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].brName !== '') {
          tableContent += details3[i].brName + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].taxableValue !== '') {
          tableContent += details3[i].taxableValue + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].nonTaxableValue !== '') {
          tableContent += details3[i].nonTaxableValue + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].cgstAmt !== '') {
          tableContent += details3[i].cgstAmt + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].sgstAmt !== '') {
          tableContent += details3[i].sgstAmt + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].igstAmt !== '') {
          tableContent += details3[i].igstAmt + "#"
        } else {
          tableContent += '  #';
        }
        contenall += tableContent;
      }
      let details = {
        headerName: "3,0,GSTR1 REPORT", headerDetails: "1,1,FROM DATE : " + gstrValues.from + "/4,1,TO DATE : " + gstrValues.to,
        tableHeader: "0,3,Sl.No/1,3,GSTIN No/2,3,Importer Name/3,3,Invoice No/4,3,Invoice Date/5,3,Invoice Value/6,3,Place Of Supply/7,3,Taxable Value/8,3,Non Taxable Value/9,3,CGST Amt/10,3,SGST Amt/11,3,IGST Amt",
        tableRowStartsFrom: 4, tableColumnStartsFrom: 0, fileCode: "gstr1", totalNumberOfColumn: 12, tableContent: contenall.substring(0, contenall.length - 1)
      }
      BillingReportsService.Excelwrite(details).then((res) => {
        const filename = res.data.message;
        // window.open('http://localhost:8080/ExportFiles/' + filename.toString(), "_blank")
        window.open('http://35.154.221.117:8081/ExportFiles/' + filename.toString(), "_blank");

      })
    }
    setexcelexportProcs(false)
  }
  useEffect(() => {
    setloading(true)
    setTimeout(() => {
      setloading(false)
    }, 1000)
    getbranch();
    getimporter();
  }, []);

  //tableSerach

  const gstNoSrch = () => {
    return <input style={{ width: '60px', textAlign: 'center', fontSize: '12px' }} placeholder="Search"
      onChange={(e) => { gstNoOnchange(e.target.value) }} />
  }
  const invoiceNoSrch = () => {
    return <input placeholder="Search" style={{ width: '60px', textAlign: 'center', fontSize: '12px' }}
      onChange={(e) => { invoiceNoOnchange(e.target.value) }} />
  }
  const impNmSrch = () => {
    return <input placeholder="Search" style={{ width: '60px', textAlign: 'center', fontSize: '12px' }}
      onChange={(e) => { impnameOnchange(e.target.value) }} />
  }
  const plcOfSplySrch = () => {
    return <input placeholder="Search" style={{ width: '60px', textAlign: 'center', fontSize: '12px' }}
      onChange={(e) => { PlaceSupplyOnchange(e.target.value) }} />
  }
  ///
  const gstNoOnchange = (searchedVal) => {
    const filteredvalue = details3.filter((trns) => {
      return trns.iecGSTINno.toString().toLowerCase().includes(searchedVal.toLowerCase());
    })
    if (filteredvalue.length < 1) {
      setFilteredDetails(details3)
    } else {
      setFilteredDetails(filteredvalue)
    }
  }
  const invoiceNoOnchange = (searchedVal) => {
    const filteredvalue = details3.filter((trns) => {
      return trns.invoiceNo.toString().toLowerCase().includes(searchedVal.toLowerCase());
    })
    if (filteredvalue.length < 1) {
      setFilteredDetails(details3)
    } else {
      setFilteredDetails(filteredvalue)
    }
  }
  const impnameOnchange = (searchedVal) => {
    const filteredvalue = details3.filter((trns) => {
      return trns.iecName.toString().toLowerCase().includes(searchedVal.toLowerCase());
    })
    if (filteredvalue.length < 1) {
      setFilteredDetails(details3)
    } else {
      setFilteredDetails(filteredvalue)
    }
  }
  const PlaceSupplyOnchange = (searchedVal) => {
    const filteredvalue = details3.filter((trns) => {
      return trns.brName.toString().toLowerCase().includes(searchedVal.toLowerCase());
    })
    if (filteredvalue.length < 1) {
      setFilteredDetails(details3)
    } else {
      setFilteredDetails(filteredvalue)
    }
  }
  //paginationCodes

  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  }
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  }

  return (
    <div>
      <Home />
      <div style={{ paddingLeft: '100px' }}>
        <Snackbar open={open} message={message} severity={severit} onClose={handleClose} />
        {loading ?
          <div className="loaderCss">
            <HashLoader
              color={"#296cbc"}
              loading={loading}
              size={50}
              aria-label="Loading Spinner"
              data-testid="loader"
            />
          </div>
          :
          <ItemPap>
            <div className='Billingtitleclr' style={{
              fontFamily: 'Times New Roman',
              color: 'red', fontWeight: 'bold', fontSize: '25px', marginTop: '1%', marginBottom: '1%',
            }}><center > GSTR1 DETAILS REPORT</center></div>
            <Row>
              <Col></Col>
              <Col><center>
                <label style={mystyle1}>FromDate</label>
                <Form.Control size="sm" type="date" style={mystyle} value={gstrValues.from} onChange={fromhandlechange} /></center>
              </Col>
              <Col>
                <center><label style={mystyle1}>ToDate</label>
                  <Form.Control size="sm" type="date" style={mystyle} value={gstrValues.to} onChange={tohandlechange} /></center>
              </Col>
              <Col>
                <center><label style={mystyle1}>Branch</label>
                  <Form.Select size="sm" style={mystyle} value={gstrValues.branch} onChange={branchhandlechange}>
                    <option value={''}> </option>
                    {details1.map(trns => (
                      <option value={trns.regionalOfficeId}>{trns.regionalName}</option>
                    ))}
                  </Form.Select></center>
              </Col>
              <Col>
                <center><label style={mystyle1}>ImporterName</label>
                  <Form.Select type="text" list="code" style={mystyle} size="sm" value={gstrValues.importer} onChange={importerhandlechange}>
                    <option value={''}> </option>
                    {details2.map(trns => (
                      <option value={trns.importer_iec_no}>{trns.importer_name}</option>
                    ))}
                  </Form.Select></center>
              </Col>
              <Col>
                <center><label style={mystyle1}>OperationType</label>
                  <Form.Select size="sm" style={mystyle} value={gstrValues.operation} onChange={operationhandlechange}>
                    <option value={'-1'}>ALL</option>
                    <option value={'IMPORT'}>IMPORT</option>
                    <option value={'EXPORT'}>EXPORT</option>
                    <option value={'COURIER'}>COURIER</option>
                  </Form.Select></center>
              </Col>
              <Col></Col>
            </Row>
            <br></br>
            <Row className="mb-1">
              <Col lg={3}></Col>
              <Col lg={6}>
                <Button variant="primary" style={{ fontFamily: 'Times New Roman'}}size="sm" onClick={showBtnClick}>{showProcs ? 'processing...' : 'Show'}  </Button>
                &nbsp;
                <Button variant="secondary" style={{ fontFamily: 'Times New Roman'}}size="sm" onClick={refreshBtnClick}>{refreshProcs ? 'processing...' : 'Refresh'}  </Button>
                &nbsp;
                <Button variant="success" style={{ fontFamily: 'Times New Roman'}}size="sm" onClick={Exp_PdfBtnClick}>{pdfexportProcs ? 'processing...' : 'Export-PDF'}   </Button>
                &nbsp;
                <Button variant="success" style={{ fontFamily: 'Times New Roman'}}size="sm" onClick={Exp_ExcelBtnClick}>{excelexportProcs ? 'processing...' : ' Export-Excel '} </Button>
              </Col>
              <Col lg={3}></Col>
            </Row>
            <ItemPap1>
              <TableContainer sx={{ height: 340 }} className="mt-1 ">
                <Table stickyHeader className="table table-bordered">
                  <TableHead>
                    <StyledTableRow>
                      <StyledTableCell>SlNo</StyledTableCell>
                      <StyledTableCell>GSTIN_No {gstNoSrch()}</StyledTableCell>
                      <StyledTableCell>ImporterName{impNmSrch()}</StyledTableCell>
                      <StyledTableCell>Invoice_No{invoiceNoSrch()}</StyledTableCell>
                      <StyledTableCell>Invoice_Date</StyledTableCell>
                      <StyledTableCell>Invoice_Value</StyledTableCell>
                      <StyledTableCell>Place_Of_Supply{plcOfSplySrch()}</StyledTableCell>
                      <StyledTableCell>Taxable_Value</StyledTableCell>
                      <StyledTableCell>NonTaxable_Value</StyledTableCell>
                      <StyledTableCell>CGST_Amt</StyledTableCell>
                      <StyledTableCell>SGST_Amt</StyledTableCell>
                      <StyledTableCell>IGST_Amt</StyledTableCell>
                    </StyledTableRow>
                  </TableHead>
                  <TableBody>
                    {FilteredDetails.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                      .map((trns, index) => (
                        <TableRow hover key={trns.serialNumber}>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.serialNumber}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.iecGSTINno}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.iecName}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.invoiceNo}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.billPaidDate}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.invoiceValue}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.brName}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.taxableValue}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.nonTaxableValue}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.cgstAmt}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.sgstAmt}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.igstAmt}</StyledTableCell>
                        </TableRow>
                      ))}
                  </TableBody>
                </Table>
              </TableContainer>
              <TablePagination
                showFirstButton
                showLastButton
                component='div'
                count={FilteredDetails.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onChangeRowsPerpage={handleChangeRowsPerPage}
              />
            </ItemPap1>
          </ItemPap>}
      </div>
    </div>
  );
}

export default GSTR1Reports;
